/**
 * PDF Text Redaction Configuration
 *
 * Add strings here that should be hidden (display: none) in the PDF sidebar
 * text layer. Each entry matches against the textContent of individual <span>
 * elements rendered by pdf.js inside `.textLayer`.
 *
 * Matching modes:
 * - "exact": span.textContent.trim() === text (default)
 * - "includes": span.textContent includes the text (hides the entire span)
 * - "startsWith": span.textContent starts with the text
 *
 * Examples:
 *   { text: "CONFIDENTIAL", mode: "exact" }
 *   { text: "Draft — not for distribution", mode: "includes" }
 *   { text: "Page ", mode: "startsWith" }
 */

export type RedactionEntry = {
  text: string;
  mode?: "exact" | "includes" | "startsWith";
};

/**
 * Configure which span text content should be hidden in the PDF viewer.
 * Add your entries below.
 */
export const PDF_TEXT_REDACTIONS: RedactionEntry[] = [
  // ── Add your redaction strings here ──────────────────────────────────────
  { text: "For evaluation purposes only. Please register an existing license (devexpress.com/DX1000)", mode: "exact" },
  { text: "or purchase a new license (devexpress.com/BUY) to continue use of DevExpress product libraries (v25.2.7.0).", mode: "exact" },
  { text: "Included in Subscriptions: Universal, Office File API.", mode: "exact" },
  // { text: "Draft — not for distribution", mode: "includes" },
];
